import * as PRESCRIPTION from '../constants/prescription';


export default {
  [PRESCRIPTION.MUTATE_LIST_PRESCRIPTION]: (state, data) => {
    state.list = data;
  }
}



// WEBPACK FOOTER //
// ./src/store/prescription/mutations.js